import { Component, OnInit, OnDestroy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { AppService } from '../../../../app.service';
import { RopeShovelService } from '../../rope-shovel.service';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute, ParamMap, Params } from '@angular/router';
import { TranslateService } from '../../../../translate';
import { EquipmentInspectionV, Loading } from '../../../../entities';
import { GeneralInspectionModel, EquipmentPhotoModel, InspectionTypeVM } from '../../models/rope-shovel.model';
import { NotificationsService } from 'angular2-notifications';
import { trigger, transition, style, animate } from '@angular/animations';
import { AvailableInspectorsViewModel } from '../../../interpretation/models/interpretation.model';
import { InterpretationService } from '../../../interpretation/interpretation.service';
import { LoadingService } from '../../../../shared/services/loading.service';
import { DatePipe } from '@angular/common';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
//We can have multiple loading in this component and each call to the server can be seen as a loading item
// getInspectionEquipment -> Loaditem -> 1
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment } from 'moment';
import { FormControl } from '@angular/forms';
import { ComponentMeasurementTableComponent } from '../../components/component-measurement-table/component-measurement-table.component'
import { UpdateEvalModel } from '../../../interpretation/interpretation.model';
import { DomSanitizer } from '@angular/platform-browser';
import { UserService } from '../../../../../app/shared/services/user.service';
import { MatDialog } from '@angular/material/dialog';import { rsreportconfigcomponent } from '../../components/report-configuration/rs-report-config.component';
import { ReportBuilderService } from '../report-builder/report-builder.service';
import { CryptoService } from '../../../../services/crypto.service';

const moment = _rollupMoment || _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: 'll',
  },
  display: {
    locale: 'en-au',
    dateInput: 'll',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'll',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
  selector: 'rope-shovel-inspection',
  templateUrl: './rope-shovel-inspection.component.html',
  styleUrls: ['./rope-shovel-inspection.component.scss'],
  animations: [
    trigger(
      'fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('500ms', style({ opacity: 0 }))
      ])
    ]
    )],

  providers: [DatePipe,
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' },
  ]
})
export class RopeShovelInspectionComponent implements OnInit {
  date = new FormControl(moment());
  translateSubscription: Subscription;
  userLanguage: string = "english";
  LoadingTable: Loading[] = [];
  loadingOverview: boolean = false;
  InspectionEquipment: EquipmentInspectionV = new EquipmentInspectionV();
  //inspectionId: number;
  selectedTab: number = 0;
  availableInspectors: AvailableInspectorsViewModel[] = [];

  _generalInspection: GeneralInspectionModel = new GeneralInspectionModel();
  overallEval: string = "U";
  overallEvalLoading: boolean = true;
  _quipmentId = 0;
  _inspectionId = 0;
  inspectionTypesList:InspectionTypeVM[];
  @ViewChild('measurementCompo')
  system: ComponentMeasurementTableComponent;
  public todate = new Date();
  //appUris: AppUris;
  downloadingPDF: boolean;
  IsReleased: boolean = false;

  constructor(private _appService: AppService, private _service: RopeShovelService,
    private _router: Router, private _route: ActivatedRoute, private ref: ChangeDetectorRef,
    private _translate: TranslateService,
    private _notify: NotificationsService,
    private _interp: InterpretationService,
    private _loading: LoadingService,
    private datePipe: DatePipe,
    private _sanitizer: DomSanitizer,
    private _user: UserService,
    private _dialog: MatDialog,
    private _rbService: ReportBuilderService,
    private _crypto: CryptoService
  ) { }

  ngOnInit() {
    this._appService.setPageTitle(this.Translate('Rope Shovel /Mining Shovel Inspection'));
    this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));
    //this._appService.getAppUris().subscribe(result => { this.appUris = result; });
    this._route.params.subscribe((params: Params) => {
      if (params['EquipmentId']) this._quipmentId = parseInt(params['EquipmentId']);
      if (params['InspectionId']) this._inspectionId = parseInt(params['InspectionId']);

      this.checkUserPermission();
      if (!isNaN(this._quipmentId) && this._quipmentId > 0) {
        this.LoadEquipment(this._quipmentId, 0);
        console.log("step_1")
        //  this.loadAvailableInspectors(this._quipmentId);
      }
      else if (!isNaN(this._inspectionId) && this._inspectionId > 0) {
        this.loadInspectionGeneral(this._inspectionId);
        console.log("step_2")

      }
      else {
        this._router.navigateByUrl('select-equipment/rs-inspection');
        this.loadAvailableInspectors(this._quipmentId);
      }





    }, error => console.error(error), () => { });


  }

  loadInspectionTypes(){
      this._interp.getInspectionTypes(this.InspectionEquipment.Equipment.MakeModelFamily.Model.Id).subscribe(res=>{
        this.inspectionTypesList = res;
      })
  }

    /**
   * Checks that the user has permission to view the page.
   */

  
  isAdmin:boolean=false;
  isInterpreter:boolean=false;
  // checkUserPermission() {
  //   this._user.getUserJobRoles().subscribe(
  //     jobRoles => {
  //       jobRoles.forEach(role => {
  //         switch (role.Name) {
  //           case 'Inspectors':
  //             break;
  //           case 'Interpreters':
  //           case 'Super User':
  //           case 'Administrator':
  //             this.isAdmin = true;
  //             break;
  //         }
  //       });
  //     },
  //     error => {
  //       console.error(error);
  //       this._notify.error('Error', 'Unable to check your job roles. ');
  //     }
  //   );
    
  // }

  checkUserPermission() {
    this._user.getUserJobRoles().subscribe(
      jobRoles => {
        jobRoles.forEach(role => {
          switch (role.Name) {
            case 'Inspectors':
              this.isInterpreter = true;
              break;
            case 'Interpreters': this.isInterpreter = true;
            case 'Super User': this.isInterpreter = true;
            case 'Administrator': this.isInterpreter = true; this.isAdmin = true;
              this.isInterpreter = true;
              break;
              case 'Customer Admin':
                this.isInterpreter = true; this.isAdmin = true;
                this.isInterpreter = true;
                break;
          }
        });
      },
      error => {
        console.error(error);
        this._notify.error('Error', 'Unable to check your job roles. ');
      }
    );

  }
  InspectionTypeChange(){
    console.log("chnage Inspection", this._generalInspection.InspectionType)
    this._interp.UpdateRSHInspectionType(this._inspectionId, this._generalInspection.InspectionType).subscribe(res=>{
      if(res.m_Item1>0){
        this._notify.success(res.m_Item2);
      }else{
        this._notify.success(res.m_Item2);

      }
    })

  }
  ngOnDestroy() {
    this.translateSubscription.unsubscribe();
  }

  prepareReport() {
    this._router.navigate(['rs-inspection/report-builder', this._generalInspection.Id]);
  }

  updateUserLang(lang: string) {
    this.userLanguage = lang;
    this.ref.detectChanges();
  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }

  loadAvailableInspectors(equipmentId) {
    console.log("equipmentId", equipmentId)
    this._quipmentId = equipmentId;
    this._interp.getAvailableInspectorsBasedOnEquipment(equipmentId).subscribe(r => {
      console.log("availableInspectors", r)
      this.availableInspectors = r;
      //AES256
      this.availableInspectors.forEach((insp: any) => {
        if (insp?.UserName && insp.UserName.length > 0) {
          insp.UserName = this._crypto.decrypt(insp.UserName);
        }
      });
    });
  }



  changedInspector(changedToInspector) {
    this._loading.startLoading();
    this._interp.changeInspectionsInspector(this._generalInspection.Id, changedToInspector.UserId).subscribe(r => {
      console.log(r);
      if (r) {
        this._notify.success(`Succefully changed inspector to ${changedToInspector.UserName}`);
        this.InspectionEquipment.Inspector.Name = changedToInspector.UserName;
      }
      else {
        this._notify.error(`Failed to change inspector`);
      }
      this._loading.finishedLoading();
    });
  }
  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl(image);
}

  updateImage(data){
    this.LoadEquipment(this.InspectionEquipment.Equipment.Id, this.InspectionEquipment.InspectionId);
  }

  LoadEquipment(Id: number, _inspectId) {
    this.pushLoading(1);
    this._service.getInspectionEquipment(Id, _inspectId).subscribe(equipment => {

      this.InspectionEquipment = equipment;
      this.InspectionEquipment.Inspector.Name = this._crypto.decrypt(this.InspectionEquipment.Inspector.Name);
      this._generalInspection.EquipmentId = this.InspectionEquipment.Equipment.Id;
      this.loadAvailableInspectors(this.InspectionEquipment.Equipment.Id);
      this.loadInspectionTypes();
      this.loadOverallEval();
    }, error => console.error(error), () => { this.popLoading(1); });
  }

oldDate:Date=new Date();
  loadInspectionGeneral(_inspectionId) {
    this.pushLoading(2);
    this._service.getInspectionGeneralAsync(_inspectionId).subscribe(generalInfo => {
      this._generalInspection = generalInfo;
      this.oldDate = this._generalInspection.Date;
      this.LoadEquipment(this._generalInspection.EquipmentId, _inspectionId);
      this.loadAvailableInspectors(this._generalInspection.EquipmentId);
      this.IsReleased = this._generalInspection.IsReleased;
    }, error => console.error(error), () => { this.popLoading(2); });
  }

  LoadingStatus(item: number): boolean {
  
    let loadItem = this.LoadingTable.find(m => m.LoadingItem == item);
    if (loadItem) return loadItem.Loading;
    return false;
  }
  pushLoading(item: number) {
    let loadItem = this.LoadingTable.find(m => m.LoadingItem == item);
    if (loadItem) { loadItem.Loading = true; return; }
    let _loadItem = new Loading();
    _loadItem.LoadingItem = item;
    _loadItem.Loading = true;
    this.LoadingTable.push(_loadItem);
  }
  popLoading(item: number) {
    let index = this.LoadingTable.findIndex(m => m.LoadingItem == item);
    if (index > -1) { this.LoadingTable.splice(index); return; }
  }

  isSaving: boolean = false;
  LoadTabGeneral(){
    console.log("selectedTab", this.selectedTab,this._inspectionId )
    if(this.selectedTab==0){
     // this.loadInspectionGeneral(this._inspectionId);

      this._service.getInspectionGeneralAsync(this._inspectionId).subscribe(generalInfo => {

        this._generalInspection = generalInfo;
      });
    }
  }

  submitSMU() {
    this._loading.startLoading();
    this.isSaving = true;
    this.pushLoading(3);
    if (this._generalInspection.Id > 0){
      this._generalInspection.oldDate =this.oldDate;
      this._service.InspectionAction(this._generalInspection).subscribe(result => {
        this.isSaving = false;
        this._loading.finishedLoading();
        this._generalInspection = result;
        if (!this._generalInspection.SMUValidationFailed) {
          this._notify.success(this.Translate('Action completed!'), this.Translate('SMU and Date updated successfully'));
          this._router.navigateByUrl('rs-inspection/' + this._generalInspection.Id);
        } else {
          this._notify.warn(this.Translate('Action Failed!'), this.Translate(this._generalInspection.SMUMessage));
          if (this._generalInspection.Id > 0) {
            this._router.navigateByUrl('rs-inspection/' + this._generalInspection.Id);
          }
        }
      }, error => console.error(error), () => { this.popLoading(3); this.isSaving = false; });
    }
    
    else {
      this.pushLoading(3);
      console.log(this._generalInspection);
      this._service.InspectionAction(this._generalInspection).subscribe(result => {
        this.isSaving = false;
        this._loading.finishedLoading();
        this._generalInspection = result;
        if (!this._generalInspection.SMUValidationFailed) {
          this._notify.success(this.Translate('Action completed!'), this.Translate('Inspection created successfully'));
          this._router.navigateByUrl('rs-inspection/' + this._generalInspection.Id);
        }
      }, error => console.error(error), () => { this.popLoading(3); this.isSaving = false; });
    }
  }

  submitPMU() {
    this._loading.startLoading();
    this.isSaving = true;
    this.pushLoading(3);
    if (this._generalInspection.Id > 0){
      this._generalInspection.oldDate =this.oldDate;
      this._service.InspectionAction(this._generalInspection).subscribe(result => {
        this.isSaving = false;
        this._loading.finishedLoading();
        this._generalInspection = result;
        if (!this._generalInspection.SMUValidationFailed) {
          this._notify.success(this.Translate('Action completed!'), this.Translate('Tramming Hours updated successfully'));
          this._router.navigateByUrl('rs-inspection/' + this._generalInspection.Id);
        } else {
          this._notify.warn(this.Translate('Action Failed!'), this.Translate('Unabled update the Tramming Hours'));
          if (this._generalInspection.Id > 0) {
            this._router.navigateByUrl('rs-inspection/' + this._generalInspection.Id);
          }
        }
      }, error => console.error(error), () => { this.popLoading(3); this.isSaving = false; });
    }
  }
  updateTrammingHours(hours: number) {
this._generalInspection.TrammingHours = hours;
    this.submitPMU();
    // this._service.updateTrammingHours(this._generalInspection.Id, hours).subscribe(r => {
    //   if (r.m_Item1) {
    //     this._notify.success('Saved', r.m_Item2);
    //   } else {
    //     this._notify.alert('Couldn\'t Save', r.m_Item2);
    //     console.log(r.m_Item2);
    //   }
    // }, err => {
    //   console.log(err);
    //   this._notify.alert('Error', 'Unable to update the tramming hours. Please contact support for help. ');
    // });
  }
  recalculateWorn(){
    this._loading.startLoading();
    this.isSaving = true;
    if (this._generalInspection.Id > 0){
      this._generalInspection.oldDate =this.oldDate;
      this._service.InspectionAction(this._generalInspection).subscribe(result => {
        this.isSaving = false;
        this._loading.finishedLoading();
        this._generalInspection = result;
        if (!this._generalInspection.SMUValidationFailed) {
          this._service.ReCalculateWornPercentage(this._generalInspection.Id).subscribe(res=>{
            if(res==true){
            this._notify.success(this.Translate('Action completed!'), this.Translate('SMU and Date updated successfully'));
            this._router.navigateByUrl('rs-inspection/' + this._generalInspection.Id);
            }
          })
          
        } else {
          this._notify.warn(this.Translate('Action Failed!'), this.Translate(this._generalInspection.SMUMessage));
          if (this._generalInspection.Id > 0) {
            this._router.navigateByUrl('rs-inspection/' + this._generalInspection.Id);
          }
        }
      }, error => console.error(error), () => { this.popLoading(3); this.isSaving = false; });
    }
  }
  updateNumberOfShoesLeft(num_of_shoe: number) {
    this._service.updateNumberOfShoesLeft(this._generalInspection.Id, num_of_shoe).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Saved', r.m_Item2);
      } else {
        this._notify.alert('Couldn\'t Save', r.m_Item2);
        console.log(r.m_Item2);
      }
    }, err => {
      console.log(err);
      this._notify.alert('Error', 'Unable to update the tramming hours. Please contact support for help. ');
    });
  }


  updateNumberOfShoesRight(num_of_shoe: number) {
    this._service.updateNumberOfShoesRight(this._generalInspection.Id, num_of_shoe).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Saved', r.m_Item2);
      } else {
        this._notify.alert('Couldn\'t Save', r.m_Item2);
        console.log(r.m_Item2);
      }
    }, err => {
      console.log(err);
      this._notify.alert('Error', 'Unable to update the tramming hours. Please contact support for help. ');
    });
  }

  updateCustomerContact(customerContact: string) {
    this._service.updateCustomerContact(this._generalInspection.Id, customerContact).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Saved', r.m_Item2);
      } else {
        this._notify.alert('Couldn\'t Save', r.m_Item2);
        console.log(r.m_Item2);
      }
    }, err => {
      console.log(err);
      this._notify.alert('Error', 'Unable to update the customer contact. Please contact support for help. ');
    });
  }

  updateGeneralInspectionNotes(notes: string) {
    this._service.updateGeneralInspectionNotes(this._generalInspection.Id, notes).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Saved', r.m_Item2);
      } else {
        this._notify.alert('Couldn\'t Save', r.m_Item2);
        console.log(r.m_Item2);
      }
    }, err => {
      console.log(err);
      this._notify.alert('Error', 'Unable to update the general inspection notes. Please contact support for help. ');
    });
  }


  updateInterpComment(notes: string) {
    this._service.updateInterpComment(this._generalInspection.Id, notes).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Saved', r.m_Item2);
      } else {
        this._notify.alert('Couldn\'t Save', r.m_Item2);
        console.log(r.m_Item2);
      }
    }, err => {
      console.log(err);
      this._notify.alert('Error', 'Unable to update the general inspection notes. Please contact support for help. ');
    });
  }
  updateImpact(impact: number) {
    this._service.updateImpact(this._generalInspection.Id, impact).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Saved', r.m_Item2);
      } else {
        this._notify.alert('Couldn\'t Save', r.m_Item2);
        console.log(r.m_Item2);
      }
    }, err => {
      console.log(err);
      this._notify.alert('Error', 'Unable to update the impact. Please contact support for help. ');
    });
  }

  updateAbrasive(abrasive: number) {
    this._service.updateAbrasive(this._generalInspection.Id, abrasive).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Saved', r.m_Item2);
      } else {
        this._notify.alert('Couldn\'t Save', r.m_Item2);
        console.log(r.m_Item2);
      }
    }, err => {
      console.log(err);
      this._notify.alert('Error', 'Unable to update the impact. Please contact support for help. ');
    });
  }

  updateMoisture(moisture: number) {
    this._service.updateMoisture(this._generalInspection.Id, moisture).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Saved', r.m_Item2);
      } else {
        this._notify.alert('Couldn\'t Save', r.m_Item2);
        console.log(r.m_Item2);
      }
    }, err => {
      console.log(err);
      this._notify.alert('Error', 'Unable to update the moisture. Please contact support for help. ');
    });
  }

  updatePacking(packing: number) {
    this._service.updatePacking(this._generalInspection.Id, packing).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Saved', r.m_Item2);
      } else {
        this._notify.alert('Couldn\'t Save', r.m_Item2);
        console.log(r.m_Item2);
      }
    }, err => {
      console.log(err);
      this._notify.alert('Error', 'Unable to update the packing. Please contact support for help. ');
    });
  }

  log(event) {
    console.log(event);
  }

  updateJobsiteComment(comment: string) {
    this._service.updateJobsiteComment(this._generalInspection.Id, comment).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Saved', r.m_Item2);
      } else {
        this._notify.alert('Couldn\'t Save', r.m_Item2);
        console.log(r.m_Item2);
      }
    }, err => {
      console.log(err);
      this._notify.alert('Error', 'Unable to update the jobsite comment. Please contact support for help. ');
    });
  }

  loadOverallEval() {
    this._interp.getOverallEval(this._inspectionId).subscribe(overallEval => {
      this.InspectionEquipment.Eval.EvalCode = overallEval;
      this.overallEvalLoading = false;
    }, err => this.handleError(err, "Can't get the overall evaluation. "))
  }

  updateOverallEval(evaluation: string) {

    this._loading.startLoading();

    let updatModel = new UpdateEvalModel();
    updatModel.inspectionId = this._inspectionId;
    updatModel.newEval = evaluation;
    this._interp.setOverallEval(updatModel).subscribe(r => {
      if (r.m_Item1) {
        this.InspectionEquipment.Eval.EvalCode = evaluation;
        this._notify.success('Saved', r.m_Item2);
        this._loading.finishedLoading();
      } else {
        this._notify.error('Error', r.m_Item2);
        console.error(r.m_Item2);
        this._loading.finishedLoading();
      }
    }, err => this.handleError(err, "Can't update the overall eval. "));
  }
  childMeasurementPointUpdated() {
    this.loadOverallEval()
  }
  changeEvalInChildClicked(data) {
    this.updateOverallEval(data);
  }

  handleError(error, message: string) {
    this._notify.error("Error", message);
    console.error(error);
    this._loading.finishedLoading();
  }

  openReportConfigurations() {
    const ReportConfigurationsModalRef = this._dialog.open(rsreportconfigcomponent, {
      width: '400px',
      height: '700px',
      data: {
        inspectionId: this._inspectionId,
      }
    });
    ReportConfigurationsModalRef.afterClosed().subscribe(details => {
      if (details != null) {
        //this.recommmendationID = 1;
      }
    });

  }

  downloadPDF() {
    //if (this.IsReleased) {
    //  this.downloadingPDF = true;
    //  this._notify.info('Preparing PDF report...', 'It may take time.');
    //  this._service.checkReportConfig(this._inspectionId, this.InspectionEquipment.Equipment.Id).subscribe(res => {
    //    if (!res) {
    //      this._notify.error("Error", "Please save report configuration before download PDF.");
    //    }
    //    else {
    //      window.open(this.appUris.UCUri + 'Api/RopeShovelInspection/GetRSPdf?InspectionId=' + this._inspectionId.toString(), '_blank');
    //    }
    //    this.downloadingPDF = false;
    //  });
    //}
    //else {
    //  this._notify.error('Error', 'Please release this report first.');
    //}
    if (this.IsReleased) {
      //window.open(this.appUris.UCUri + 'Api/RopeShovelInspection/GetRSPdf?InspectionId=' + this._inspectionId.toString(), '_blank');
      window.open(this._appService.getBaseURL() + 'Api/RopeShovelInspection/GetRSPdf?InspectionId=' + this._inspectionId.toString(), '_blank');
    }
    else {
      this._notify.error('Error', 'Please release this report first.');
    }
  }
  ReleaseReport() {
    //console.log("REPORT", this.MSInspectionID)
    //this._service.checkReportConfig(this._inspectionId, this.InspectionEquipment.Equipment.Id).subscribe(res => {
    //  if (!res) {
        this._rbService.releaseRopeReport(this._inspectionId).subscribe(r => {
          if (r.m_Item1) {
            this._notify.success('Released', r.m_Item2);
            this.IsReleased = true;
          } else {
            this._notify.error('Failed', 'Unable to release report. Contact TrackTreads support for help. ');
            console.log(r.m_Item2);
            this.IsReleased = false;
          }

        });
    //  }
    //});
  }
  sendReport() {
    //let sendReportModalRef = this.sendReportModalComponent.open(SendReportModalComponent, {
    //  width: '640px',
    //  height: '500px',
    //  data: { MSInspectionID: this._inspectionId, ReportUoM: this.pdfUoM, styleId: this.ropeStyleId }
    //});
    //sendReportModalRef.afterClosed().subscribe(res => {
    //  if (res != null) {
    //    // var sendToAddress: string = res.data;
    //    // this._rbService.SendReport(this.MSInspectionID, sendToAddress).subscribe(r2 => {
    //    //     if (r2 != null && r2 == true) {
    //    //         alert("Successfully sent report.");
    //    //     } else {
    //    //         alert("Failed to send report!");
    //    //     }
    //    // });
    //  }
    //});
  }
  translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }


}
